const devServerURL = "https://operator.zingmobility.com/v1";
export let baseURL = devServerURL;

export const businessModelType = [
  { value: "BUSOWNER", label: "MG" },
  { value: "ELECTRIC", label: "ELECTRIC" },
  { value: "OPERATOR", label: "GDS" },
];
export const tracerUrl = "https://testtracker.zingmobility.com/";

export const inspectionOptions = [
  {
    value: "inspectionone",
    label: "Inspection Data 1",
  },
  {
    value: "inspectiontwo",
    label: "Inspection Data 2",
  },
  {
    value: "inspectionthree",
    label: "Inspection Data 3",
  },
];
export const AuditOptions = [
  {
    value: "onboardingAudit",
    label: "Onboarding Audit",
  },
  {
    value: "RegularAudit",
    label: "Regular Audit",
  },
];
export const operatorType = {
  CABOWNER: "CABOWNER",
  BUSOWNER: "BUSOWNER",
};
export const cloundFrontBaseUrl = "https://d370edwo3kkakj.cloudfront.net/";

export const capchaKey = "6LfXVU8eAAAAABOhUt2yjj313QfNUmlWn7PyX4bk";

export const defaultSearchDateRanges = {
  fmlmPaymentSummarySearch: {
    fromDate: new Date(new Date().setDate(new Date().getDate() - 7)).setHours(
      0,
      0,
      0,
      0
    ),
    toDate: new Date().setHours(23, 59, 59, 999),
  },
  fmlmTripSearch: {
    fromDate: new Date().getTime() - 12 * 60 * 60 * 1000,
    toDate: new Date().getTime() + 12 * 60 * 60 * 1000,
  },
};
export const routeTypes = ["Inter", "Intra"];
export const mixPanelToken = "d1a687526f1f9d398c0143a55cb30431";

export const isStage = true;
